/**
 * @property {boolean} isMobile
 * @property {boolean} isChrome
 * @property {boolean} isExplorer
 * @property {boolean} isFireFox
 * @property {boolean} isOpera
 * @property {boolean} isIpad
 * @property {boolean} isTablet
 * @property {boolean} isIphone
 * @property {boolean} isSafari
 * @property {boolean} isAndroid
 * @property {boolean} isIos
 * @property {boolean} isMacOSx
 * @property {boolean} isEdge
 * @property {boolean} hasTouch
 */
export default class UserAgent {
    constructor() {
        this.ua = navigator.userAgent.toLowerCase();

        //browsers
        this.isChrome = this.match('chrome');
        this.isExplorer = this.match('msie');
        this.isFireFox = this.match('firefox');
        this.isSafari = this.match('safari');
        this.isOpera = this.match('presto');
        this.isEdge = this.match('edge');

        if (this.isChrome && this.isSafari) {
            this.isSafari = false;
        }

        this.isIphoneNoticeDisabled = false;
        this.hasTouch = ('ontouchstart' in window);

        //phone types
        this.isAndroid = this.match('android');
        this.isWindowsPhone = this.match('windows phone');
        this.isTablet = (! this.match('mobile') && this.isAndroid) || this.isIpad;
        this.isMacOSx = this.match('macintosh');
        this.isMobile = (this.isSafari && ! this.isMacOSx) || this.isAndroid || this.isIpad || this.isIphone || this.isWindowsPhone;
        this.isIpad = this.match('ipad') || this.isIpadInDesktopMode();
        this.isIphone = this.match('iphone') && ! this.isWindowsPhone;
        this.isIos = this.isIpad || this.isIphone;
    }

    isIpadInDesktopMode() {
        return this.hasTouch && this.isMacOSx;
    }

    /**
     * @public
     * @returns {boolean}
     */
    hasNoOpenerSupport() {
        return ! this.isExplorer && ! this.isEdge;
    }

    /**
     * @public
     * @returns {boolean}
     */
    shouldUseApp() {
        return this.iphoneOsVersion() < 10;
    }

    /**
     * @private
     * @returns {number}
     */
    iphoneOsVersion() {
        const regex = /iphone os (\d+)/i;
        let match;

        if ((match = regex.exec(this.ua)) !== null) {
            if (match.index === regex.lastIndex) {
                regex.lastIndex++;
            }

            return parseInt(match[1]);
        }

        return -1;
    }

    /**
     * @public
     * @returns {boolean}
     */
    isIphoneApp() {
        return this.isIphone && this.isIphoneNoticeDisabled;
    }

    /**
     * @public
     * @returns {boolean}
     */
    shouldHideInteractiveLayer() {
        if (this.isIphone) {
            return ! this.shouldUseApp() || this.iPhoneCanPlayInFacebookApp();
        }

        return this.isIpad || this.isAndroid;
    }

    /**
     * @public
     * @returns {boolean}
     */
    iPhoneCanPlayInFacebookApp() {
        return this.isIphone && this.isIphoneFacebookApp() && ! this.shouldUseApp();
    }

    /**
     * @public
     * @returns {boolean}
     */
    isIphoneFacebookApp() {
        return !! this.ua.match(/(FBAN|FBAV)/gi);
    }

    hasMouse() {
        return matchMedia('(hover:hover)').matches;
    }

    /**
     * @private
     * @param {string} testString
     * @returns {boolean}
     */
    match(testString) {
        return this.ua.includes(testString);
    }

    /**
     * @public
     * @returns {void}
     */
    disableIphoneNotice() {
        this.isIphoneNoticeDisabled = true;
    }
}
